"use client";
import React from "react";
import FooterSocials from "./FooterSocials";

import { useTranslation } from 'react-i18next';

// Casilla de WorkMail: lo que llega entra a la bandeja del admin (origen "contacto").
const CONTACT_EMAIL = "contacto@briancallimusic.com";

export default function FooterPreview() {
  const { t } = useTranslation();

  const scrollToTop = (event) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Linear easing replacement
    });
  };

  return (
    <div className="container">
      <div className="row pb-20 pb-sm-80 pb-xs-50">
        <div className="col-xl-10">
          <div className="row mt-n30">
            {/* Footer Widget */}
            {/* End Footer Widget */}
            {/* Footer Widget */}
            <div className="col-sm-4 mt-30">
              <h3 className="fw-title">{t('social_media')}</h3>
              <ul className="fw-menu clearlist">
                <FooterSocials />
              </ul>
            </div>
            {/* End Footer Widget */}
            {/* Footer Widget */}
            <div className="col-sm-4 mt-30">
              <h3 className="fw-title">{t('legal')}</h3>
              <ul className="fw-menu clearlist">
                <li>
                  <a href="/politica-privacidad">{t('privacy_policies')}</a>
                </li>
                <li>
                  <a href="/terminos-uso">{t('terms_of_use')}</a>
                </li>
                <li>
                  <a href="/politica-cookies">{t('cookie_policy')}</a>
                </li>
                <li>
                  <a href="/aviso-legal">{t('legal_notice')}</a>
                </li>
              </ul>
            </div>
            {/* End Footer Widget */}
            {/* Footer Widget */}
            {/* El mail no entra en un tercio de ancho hasta lg: abajo va en su propia fila */}
            <div className="col-sm-12 col-lg-4 mt-30">
              <h3 className="fw-title">{t('contact')}</h3>
              <ul className="fw-menu clearlist">
                <li>
                  <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                </li>
              </ul>
            </div>
            {/* End Footer Widget */}
          </div>
        </div>
      </div>
      {/* Footer Text */}
      <div className="row text-gray">
        <div className="col-md-4 col-lg-3">
          <b>© Brian Calli Music {new Date().getFullYear()}.</b>
        </div>
        <div className="col-md-7 offset-md-1 offset-lg-2 clearfix">
          {/* Back to Top Link */}
          <div
            className="local-scroll float-end mt-n20 mt-sm-10"
            onClick={scrollToTop}
          >
            <a href="#top" className="link-to-top">
              <i className="mi-arrow-up size-24" />
              <span className="visually-hidden">{t('scroll_to_top')}</span>
            </a>
          </div>
          {/* End Back to Top Link */}
        </div>
      </div>
      {/* End Footer Text */}
    </div>
  );
}
